/** Initialele majuscule ale fiecarui cuvant din fullName: "Gabriela Comanoiu" -> "GC". */
export function getEmployeeInitials(fullName: string): string {
  return fullName
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('')
}

/** Formateaza docns: DSM.{initials}.{period}.{counter_pad3}. Returneaza null daca decontul n-a fost exportat. */
export function formatDocns(
  fullName: string,
  period: string,
  numarDecont: number | null,
): string | null {
  if (numarDecont == null) return null
  const initials = getEmployeeInitials(fullName)
  const counter = String(numarDecont).padStart(3, '0')
  return `DSM.${initials}.${period}.${counter}`
}
